import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { getManageableRoles } from '../../services/UserService'
import { ROLE_SLUGS } from '../../utils/auth/permissionConstants'

const RolesAndPermissions = () => {
    const userRole = useSelector((state) => state.auth.authUser?.role_slug)
    const { status, data, error } = useQuery({
        queryKey: ['roles-with-permissions'],
        queryFn:  getManageableRoles,
        staleTime: 5 * 60 * 1000,
        enabled:  userRole === ROLE_SLUGS.EXEC_ADMIN,
    })

    const roles = data?.data?.data ?? []

    if (userRole !== ROLE_SLUGS.EXEC_ADMIN) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <p className="text-muted mb-0">You do not have permission to view this page.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <div className="row mb-4">
                <div className="col-12">
                    <h4 className="mb-1">Roles &amp; Permissions</h4>
                    <p className="text-muted mb-0">Each role and its associated permissions.</p>
                </div>
            </div>

            {status === 'pending' ? (
                <div className="row">
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading…</span>
                        </div>
                    </div>
                </div>
            ) : error ? (
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-danger">
                            Failed to load roles. Please try again.
                        </div>
                    </div>
                </div>
            ) : roles.length === 0 ? (
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <p className="text-muted mb-0">No roles found.</p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="row g-4">
                    {roles.map((role) => (
                        <div key={role.id} className="col-12 col-md-6 col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5 className="mb-0">{role.name}</h5>
                                </div>
                                <div className="card-body">
                                    {role.permissions.length === 0 ? (
                                        <p className="text-muted mb-0 small">No permissions assigned.</p>
                                    ) : (
                                        <div className="d-flex flex-wrap gap-2">
                                            {role.permissions.map((permission) => (
                                                <span key={permission.id} className="badge bg-primary">
                                                    {permission.title}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Fragment>
    )
}

export default RolesAndPermissions
